import {
  makeSkillWebCompaniesRedirectUrl,
  makeSkillWebInstitutionsRedirectUrl,
  makeSkillWebManagerUsersRedirectUrl,
  makeSkillWebRequestsRedirectUrl
} from '@/main/factories/http'
import PathConstants from '@/main/routes/paths'
import { Box, Container, Tabs, useTheme } from '@mui/material'
import { TabApp } from '@presentation/components/ui/navigation/tab/tab-app'
import { SyntheticEvent, useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { AnalyticsEventName } from '@/infra/tracking/analytics-event-names'
import { AnalyticsTracker } from '@/infra/tracking'
import { FeatureFlagName, useFeatureFlags } from '@/infra/feature-flag'

export function DesktopNavMenuInternalCompanyManager() {
  const theme = useTheme()
  const {
    INTERNAL_COMPANY_MANAGER_USER_BATCH_DISABLE,
    INTERNAL_COMPANY_MANAGER_INVOICE,
    INTERNAL_COMPANY_MANAGER_COMPANIES,
    COMPANY_MANAGER_COLLABORATORS,
    COMPANY_MANAGER_AUTHORIZATIONS
  } = PathConstants.Routes
  const location = useLocation()
  const [tabSelectedValue, setTabSelectedValue] = useState<string | false>(false)

  const { useNewCollaboratorsFlow, useNewAuthorizationsFlow, useNewCompanyManager } = useFeatureFlags({
    useNewCollaboratorsFlow: FeatureFlagName.ENABLE_NEW_COLLABORATORS_FLOW,
    useNewAuthorizationsFlow: FeatureFlagName.ENABLE_NEW_AUTHORIZATIONS_FLOW,
    useNewCompanyManager: FeatureFlagName.ENABLED_NEW_COMPANY_MANAGER
  })

  const handleTabClick = (_: SyntheticEvent, newValue: string | false) => {
    AnalyticsTracker.trackEvent(AnalyticsEventName.HEADER_NAV_MENU, {
      open: newValue
    })
  }

  const identifyLocation = (): string | false => {
    const routes = [
      INTERNAL_COMPANY_MANAGER_USER_BATCH_DISABLE,
      INTERNAL_COMPANY_MANAGER_INVOICE,
      INTERNAL_COMPANY_MANAGER_COMPANIES,
      COMPANY_MANAGER_COLLABORATORS,
      COMPANY_MANAGER_AUTHORIZATIONS
    ]
    return routes.find(route => route.value === location.pathname)?.name ?? false
  }

  useEffect(() => {
    const locationValue = identifyLocation()
    setTabSelectedValue(locationValue)
  }, [location])

  const tabsSx = {
    minHeight: theme.spacing(8),
    height: theme.spacing(8)
  }

  return (
    <Container maxWidth="lg" disableGutters>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Tabs
          value={tabSelectedValue}
          onChange={handleTabClick}
          variant="scrollable"
          allowScrollButtonsMobile
          sx={{
            height: theme.spacing('auto')
          }}
        >
          <TabApp
            component={Link}
            to={
              useNewCollaboratorsFlow
                ? COMPANY_MANAGER_COLLABORATORS.value
                : makeSkillWebManagerUsersRedirectUrl()
            }
            label={
              useNewCollaboratorsFlow
                ? COMPANY_MANAGER_COLLABORATORS.title
                : INTERNAL_COMPANY_MANAGER_USER_BATCH_DISABLE.title
            }
            value={
              useNewCollaboratorsFlow
                ? COMPANY_MANAGER_COLLABORATORS.name
                : INTERNAL_COMPANY_MANAGER_USER_BATCH_DISABLE.name
            }
            selectedValue={tabSelectedValue}
            sx={tabsSx}
          />

          <TabApp
            component={Link}
            to={
              useNewAuthorizationsFlow
                ? COMPANY_MANAGER_AUTHORIZATIONS.value
                : makeSkillWebRequestsRedirectUrl()
            }
            label={useNewAuthorizationsFlow ? COMPANY_MANAGER_AUTHORIZATIONS.title : 'Pedidos'}
            value={useNewAuthorizationsFlow ? COMPANY_MANAGER_AUTHORIZATIONS.name : 'Orders'}
            selectedValue={tabSelectedValue}
            sx={tabsSx}
          />

          <TabApp
            component={Link}
            to={INTERNAL_COMPANY_MANAGER_INVOICE.value}
            label={INTERNAL_COMPANY_MANAGER_INVOICE.title}
            value={INTERNAL_COMPANY_MANAGER_INVOICE.name}
            selectedValue={tabSelectedValue}
            sx={tabsSx}
          />

          <TabApp
            component={Link}
            to={makeSkillWebInstitutionsRedirectUrl()}
            label="Parceiros"
            value="Institutions"
            selectedValue={tabSelectedValue}
            sx={tabsSx}
          />

          <TabApp
            component={Link}
            to={
              useNewCompanyManager
                ? INTERNAL_COMPANY_MANAGER_COMPANIES.value
                : makeSkillWebCompaniesRedirectUrl()
            }
            label="Empresas"
            value={
              useNewCompanyManager
                ? INTERNAL_COMPANY_MANAGER_COMPANIES.name
                : 'Companies'
            }
            selectedValue={tabSelectedValue}
            sx={tabsSx}
          />
          <TabApp
            component="a"
            href="https://unicoskill.app.n8n.cloud/form/catalog-importer"
            target="_blank"
            rel="noopener noreferrer"
            label="Importar Catálogo"
            value="ImportCatalog"
            selectedValue={tabSelectedValue}
            sx={tabsSx}
          />
        </Tabs>
      </Box>
    </Container>
  )
}
